import { useCallback, useState } from 'react';

export interface IShow {
  type: string;
  data?: {
    [key: string]: any;
  };
}

export const useToggle = (initShow?: boolean | IShow) => {
  const [isShow, setShow] = useState<boolean | IShow | any>(initShow || false);

  const show = useCallback((data?: IShow) => setShow(data || true), []);

  const hide = useCallback(() => setShow(false), []);

  return { isShow, show, hide };
};
